import { useEffect, useRef } from 'react'

const useScrollBlur = () => {
  const initialized = useRef(false)

  useEffect(() => {
    if (initialized.current) return
    initialized.current = true

    const sections = Array.from(document.querySelectorAll('main section[id]'))
    if (!sections.length) return

    const setBlurForIndex = (activeIndex) => {
      sections.forEach((sec, i) => {
        if (i < activeIndex) {
          sec.classList.add('scrolled-past')
        } else {
          sec.classList.remove('scrolled-past')
        }
      })
    }

    // Observe which section is currently in view
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = sections.findIndex((s) => s.id === entry.target.id)
            if (idx !== -1) setBlurForIndex(idx)
          }
        })
      },
      { threshold: 0.45 }
    )

    sections.forEach((s) => observer.observe(s))

    // ensure initial state
    setTimeout(() => {
      const rects = sections.map((s) => ({ id: s.id, top: s.getBoundingClientRect().top }))
      const firstVisible = rects.findIndex((r) => r.top >= 0)
      setBlurForIndex(firstVisible === -1 ? 0 : firstVisible)
    }, 80)

    return () => observer.disconnect()
  }, [])
}

export default useScrollBlur
